import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MapSettingsAppState } from "../../models/state/map-settings-app-state";
import { urlHasLocationInfo } from "../../functions/url/check-url-for-map-params";
import { getLocationFromUrl } from "../../functions/url/get-location-from-url";
import { LocationZoomSettings } from "../../models/map-settings";

export const mapSettingsSlice = createSlice({
	name: "mapSettings",
	initialState: {
		path: "",
		mapMoved: false,
		mapZoomed: false,
		locationZoomSettings: { lat: 0, lng: 0, zoom: 7, radius: 500 },
		withinRadius: 0,
	} as MapSettingsAppState,

	reducers: {
		setInitialMapSettingsStateFromUrl: (
			state,
			action: PayloadAction<string>,
		) => {
			//On the initial load check if the url has location parameters,
			// if so use that for the initial search otherwise use the path like /texas/dallas
			if (urlHasLocationInfo(action.payload)) {
				let locationFromUrl = getLocationFromUrl(action.payload);

				state.locationZoomSettings = locationFromUrl;
			} else {
				state.path = new URL(action.payload).pathname;
			}
		},
		setLocationZoomSettings: (
			state,
			action: PayloadAction<LocationZoomSettings>,
		) => {
			state.locationZoomSettings = action.payload;

			//Set the within radius every time the settings are updated and the radius is different
			//This is used to show the "within X miles" text in the new home area above the result list.
			//We are not just using the location zoom settings radius because when we set just that in the
			//regular settings it kicks off another api call so for direct hits we get multiple api
			//calls in a row unnecessarily from the app-manager component.
			if (action.payload.radius > 0) {
				if (state.withinRadius !== action.payload.radius) {
					state.withinRadius = action.payload.radius;
				}
			}
		},
		setMapMoved: (state, action: PayloadAction<boolean>) => {
			state.mapMoved = action.payload;
		},
		setMapZoomed: (state, action: PayloadAction<boolean>) => {
			state.mapZoomed = action.payload;
		},
		setWithinRadius: (state, action: PayloadAction<number>) => {
			state.withinRadius = action.payload;
		},
	},
});

export const {
	setLocationZoomSettings,
	setMapMoved,
	setMapZoomed,
	setInitialMapSettingsStateFromUrl,
	setWithinRadius,
} = mapSettingsSlice.actions;

export default mapSettingsSlice.reducer;
